import type { APIResult } from "./types";

import { getMaintenanceLightingChecks } from "./generated/calls/maintenance-lighting-checks/maintenance-lighting-checks";
import type { MaintenanceLightingChecks as MaintenanceLightingCheckDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceLightingCheckDTO };

/**
 * Fetches all fleet maintenance lighting checks from the API.
 *
 * Returns an API result containing the fetched lighting checks, or a
 * controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceLightingChecks(): Promise<
  APIResult<MaintenanceLightingCheckDTO[]>
> {
  try {
    const headers = buildHeaders();
    const lightingChecksFetchRes = await getMaintenanceLightingChecks(
      undefined,
      { headers },
    );

    switch (lightingChecksFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: lightingChecksFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", lightingChecksFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
